import { Dictionary, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';

import { SharedEntityState, SharedEntityStateSelectors } from './models';

export function createSelectorsFactory<T>() {
  function getSelectors(
    selectAll: (state: EntityState<T>) => T[],
    selectEntities: (state: EntityState<T>) => Dictionary<T>,
    selectState: (state: any) => SharedEntityState<T>
  ): SharedEntityStateSelectors<T, SharedEntityState<T>> {
    const loadedAll = createSelector(
      selectState,
      (state: SharedEntityState<T>) => state.loadedAll
    );

    const getAll = createSelector(selectState, (state: SharedEntityState<T>) =>
      selectAll(state)
    );

    const getAllEntities = createSelector(
      selectState,
      (state: SharedEntityState<T>) => selectEntities(state)
    );

    return {
      loadedAll,
      getAll,
      getAllEntities,
    };
  }

  return { getSelectors };
}
